
import React from 'react';
import { Grid, Typography } from "@material-ui/core";

const ICON_NOMATCH = require("../../images/bg/nomatch.png");
const ICON_GIF = require("../../images/bg/ballLoad.gif");

export default class NoMatch extends React.Component {


    render() {

        const {isLoading} = this.props
        
        return (
            <Grid container direction='column' alignItems='center'>
                {
                    isLoading &&
                    <div style={{display:'flex',alignItems:'center',flexDirection:'column'}}>
                        < img src={ICON_GIF} style={{ width: 280, height: 280, objectFit: 'scale-down' }}></img>
                        <Typography style={{ fontSize: 12, color: '#878787', }} >赛事正在加载中...</Typography>
                    </div>
                }

                {!isLoading &&
                    <div style={{display:'flex',alignItems:'center',flexDirection:'column'}}>
                        <img src={ICON_NOMATCH} style={{marginTop:100, width: 180, height: 180, objectFit: 'scale-down' }}></img>
                        <Typography style={{ fontSize: 12, color: '#878787', }} >暂无直播，去其他栏目看看～</Typography>
                    </div>
                }


            </Grid >
        );
    }
}